export const enum GlobalSettingsKeys {
  startupTimeDifference = 'startupTimeDifference',
  allowProfileSwitching = 'allowProfileSwitching',
  reminderBeforeTimes = 'reminderBeforeTimes',

  maxAllowedProfiles = 'maxAllowedProfiles',
  maxLengthProfileName = 'maxLengthProfileName',

  showAdultPage = 'showAdultPage',

  playerBreakvertisingTime = 'playerBreakvertisingTime',

  analyticsFlushPeriod = 'analyticsFlushPeriod',
  analyticsPostBatchSize = 'analyticsPostBatchSize',
  maxNrOfFailedAnalytics = 'maxNrOfFailedAnalytics',
  stackTraceMaximumLines = 'stackTraceMaximumLines',

  favoriteCacheExpiration = 'favoriteCacheExpiration',

  reminderCacheExpiration = 'reminderCacheExpiration',

  quoteCacheExpiration = 'quoteCacheExpiration',

  bookmarkCacheExpiration = 'bookmarkCacheExpiration',
  recentBookmarkCacheWindowMs = 'recentBookmarkCacheWindowMs',
  bookmarksMaximumPercent = 'bookmarksMaximumPercent',

  recordingCacheExpiration = 'recordingCacheExpiration',
  recordingAfterTimes = 'recordingAfterTimes',
  recordingBeforeTimes = 'recordingBeforeTimes',
  recordingDefaultBeforeTime = 'recordingDefaultBeforeTime',
  recordingDefaultAfterTime = 'recordingDefaultAfterTime',
  recordingDefaultDeleteProtection = 'recordingDefaultDeleteProtection',

  epgPastDays = 'epgPastDays',
  epgFutureDays = 'epgFutureDays',

  npvrRecordingAboutToExpireInterval = 'npvrRecordingAboutToExpireInterval',

  maxResolution = 'maxResolution',

  playerLivePauseResumeCompensation = 'playerLivePauseResumeCompensation',
  playerPauseStopPlayerTime = 'playerPauseStopPlayerTime',
  playerStillPlayingTime = 'playerStillPlayingTime',
  playerBookmarkTime = 'playerBookmarkTime',
  playerWatchlistTime = 'playerWatchlistTime',
  playerWatchlistTimeRandomMs = 'playerWatchlistTimeRandomMs',
  playerHideControlsPeriod = 'playerHideControlsPeriod',
  defaultKeepaliveTimeout = 'defaultKeepaliveTimeout',
  maxKeepAliveErrors = 'maxKeepAliveErrors',
  playerToLinearConfirmation = 'playerToLinearConfirmation',
  playerFastForwardVod = 'playerFastForwardVod',
  playerRewindVod = 'playerRewindVod',
  playerProgressUpdatePeriod = 'playerProgressUpdatePeriod',
  seekTimeout = 'seekTimeout',
  playerQualityHideFps = 'playerQualityHideFps',
  fastForwardStopTime = 'fastForwardStopTime',
  playerEpgBookmarkEndOffset = 'playerEpgBookmarkEndOffset',

  broadpeakAnalyticsEnabled = 'broadpeakAnalyticsEnabled',
  broadpeakAnalyticsServer = 'broadpeakAnalyticsServer',

  swipePollTimeout = 'swipePollTimeout',
  swipePollIncrement = 'swipePollIncrement',

  searchMinChars = 'searchMinChars',
  searchKeyTimeout = 'searchKeyTimeout',
  searchMaxSuggestionLength = 'searchMaxSuggestionLength',

  decimalCount = 'decimalCount',
  decimalDivider = 'decimalDivider',

  showSeriesWatchButton = 'showSeriesWatchButton',
  showVodTitles = 'showVodTitles',
  showMiniDetailInsideDetail = 'showMiniDetailInsideDetail',
  showParentalIcons = 'showParentalIcons',

  useOldEpgCards = 'useOldEpgCards',
  allowUnauthenticatedUse = 'allowUnauthenticatedUse',
  chromeCast4kDevices = 'chromeCast4kDevices',
  displaySubtitleTeletextId = 'displaySubtitleTeletextId',
  broadpeakAnalyticsDomain = 'broadpeakAnalyticsDomain',

  chromeCastEnabled = 'chromeCastEnabled',
  unauthorizedAnalytics = 'unauthorizedAnalytics',

  playerInitialBitrate = 'playerInitialBitrate',
  playerInitialBitrate4K = 'playerInitialBitrate4K',

  restartLinearStreams = 'restartLinearStreams',
  enablePurchases = 'enablePurchases',

  showAccessibilityIcons = 'showAccessibilityIcons',
  preferredDrmProvider = 'preferredDrmProvider',

  epgShowMiniGuideSeasonAndEpisode = 'epgShowMiniGuideSeasonAndEpisode',

  restartLinearStreamFraction = 'restartLinearStreamFraction',
  continueWatchingBeforeStreamEndTime = 'continueWatchingBeforeStreamEndTime',
  continueWatchingPopupDuration = 'continueWatchingPopupDuration',
  maxLinearStreamTimeOptions = 'maxLinearStreamTimeOptions',
  defaultMaxLinearStreamTime = 'defaultMaxLinearStreamTime',
}
